import { ActivityPluginRegistry } from "../../registry/ActivityPluginRegistry";
import { MessageTypes } from "../../../entities/ActivityTypes";
import { ActivitySmsCard } from "./ActivitySmsCard";

ActivityPluginRegistry.register({
  key: "1:2",
  matches: (item) => item.Entity === 1 && item.Type === MessageTypes.SMS,
  Component: ActivitySmsCard
});
